import { ShoppingBag, CheckCircle2, ShoppingCart, TrendingUp, Globe } from "lucide-react";
import { MetricCard } from "./KarolMetricsCards";

const CONVERSION_STYLES = {
  unknown: { label: "Desconhecida", color: "text-gray-400 bg-gray-100" },
  weak:    { label: "Fraca",        color: "text-red-700 bg-red-50" },
  normal:  { label: "Normal",       color: "text-amber-700 bg-amber-50" },
  strong:  { label: "Forte",        color: "text-emerald-700 bg-emerald-50" },
};

const CHANNEL_LABELS = {
  online: "Online", pos: "POS", whatsapp: "WhatsApp",
  table: "Mesa", aggregator: "Agregador", other: "Outro",
  public: "Menu público", menu: "Menu digital",
};

export function KarolMenuIntelligenceSection({ menuIntelligence }) {
  if (!menuIntelligence || menuIntelligence.error) return null;

  const conv  = CONVERSION_STYLES[menuIntelligence.estimated_menu_conversion_signal]
              ?? CONVERSION_STYLES.unknown;
  const topCh = menuIntelligence.top_order_channels?.[0];

  return (
    <div className="space-y-3" data-testid="menu-intelligence">
      <div className="flex items-center gap-2 px-1">
        <div className="h-px flex-1 bg-gray-100" />
        <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">
          Inteligência do menu público
        </span>
        <div className="h-px flex-1 bg-gray-100" />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        <MetricCard
          icon={ShoppingBag}
          label="Pedidos pelo menu"
          value={menuIntelligence.orders_from_menu_count ?? 0}
        />
        <MetricCard
          icon={CheckCircle2}
          label="Pagos pelo menu"
          value={menuIntelligence.paid_orders_from_menu_count ?? 0}
          accent
        />
        <MetricCard
          icon={ShoppingCart}
          label="Abandonos"
          value={menuIntelligence.abandoned_from_menu_count ?? 0}
        />
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className={`flex items-center gap-2 px-3 py-3 rounded-xl text-sm font-medium ${conv.color}`}>
          <TrendingUp className="w-4 h-4 flex-shrink-0" />
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-wide opacity-70 mb-0.5">
              Conversão estimada
            </p>
            <p className="font-bold">{conv.label}</p>
          </div>
        </div>

        {topCh ? (
          <div className="bg-white rounded-xl border border-gray-100 shadow-sm px-3 py-3 flex items-center gap-2">
            <Globe className="w-4 h-4 text-gray-400 flex-shrink-0" />
            <div className="min-w-0">
              <p className="text-[10px] text-gray-400 uppercase tracking-wide mb-0.5">Canal dominante</p>
              <p className="text-sm font-semibold text-gray-800 truncate capitalize">
                {CHANNEL_LABELS[topCh.channel] ?? topCh.channel}
              </p>
            </div>
          </div>
        ) : (
          <div className="bg-gray-50 rounded-xl px-3 py-3 flex items-center gap-2">
            <Globe className="w-4 h-4 text-gray-300 flex-shrink-0" />
            <p className="text-xs text-gray-400">Sem canal registado</p>
          </div>
        )}
      </div>
    </div>
  );
}
